export default function cleanDateString (str) {
  // replace hyphens with slashes and remove ms to fix safari date parsing
  return str
    .replace(/-/g, '/')
    .replace('T', ' ')
    .replace(/(\..*|\+.*)/, '')
    .replace(/([0-9]+:[0-9]+:[0-9]+)\/(\d)+/, '$1')
}
